import React, { useState, useEffect, useMemo } from "react";
import { Axios } from './UserContext';

// CSS PDF-u

import { style_list } from './Style';

// Czcionki

import RobotoBold from '../fonts/roboto_bold.ttf';
import RobotoMedium from '../fonts/roboto_medium.ttf';
import RobotoMonoItalic from '../fonts/roboto_mono_italic.ttf';

// Obrazy

import Logo from '../images/logo.png';
import FrontPage from '../images/front_page.jpg';
import CompanyPage from '../images/company_page.jpg';

// PDF

import { PDFDownloadLink, Font, Page, Text, View, Document, Image, Link, StyleSheet } from '@react-pdf/renderer';

export default function Main(){

    // Style

    const styles = StyleSheet.create(style_list);

    // Czcionki

    Font.register({
        family: 'roboto_bold',
        src: RobotoBold,
        format: 'truetype',
    });

    Font.register({
        family: 'roboto_mono_italic',
        src: RobotoMonoItalic,
        format: 'truetype',
    });

    Font.register({
        family: 'roboto_medium',
        src: RobotoMedium,
        format: 'truetype',
    });

    Font.registerHyphenationCallback(word => (
        [word]
    ));

    // Aktualna data

    const [currentYear, setCurrentYear] = useState(null);

    useEffect(() => {

        const year = new Date().getFullYear();

        setCurrentYear(year);

    }, []);

    // Modal

    const [modalMessage, setModalMessage] = useState(null);

    const [modal, setModal] = useState({
        show: false, 
        info: false
    });

    function closeModal(){

        setModal({
            show: false,
            info: false
        });

    }

    // Pobieranie danych

    const [receivedData, setReceivedData] = useState(null);

    useEffect(() => {

        getData();

        function getData(){

            let request_type = 'get catalog data';
    
            Axios.post('classes/data.php', { request_type }, { timeout: 10000 }).then(function(response){

                if(typeof response.data === 'object' || Array.isArray(response.data)){

                    setReceivedData(response.data);

                } else {

                    setModal({show: true, info: true});

                    setModalMessage('Wystąpił błąd w trakcie pobierania danych.');

                }

            }).catch((error) => {

                console.warn(error);

                setModal({show: true, info: true});

                setModalMessage('Wystąpił błąd w trakcie pobierania danych.');

            });
    
        }

    }, []);

    const [productList, setProductsList] = useState([]);

    useEffect(() => {

        if(receivedData){

            const products = receivedData.products ? receivedData.products : [];

            const categories = receivedData.categories ? receivedData.categories : [];

            const subcategories = receivedData.subcategories ? receivedData.subcategories : [];

            products.forEach(product => {

                const category_id = product.category_id;

                const subcategory_id = product.subcategory_id;

                const category_match = categories.find(item => item.category_id === category_id);

                if(category_match){

                    product.category_name = category_match.category_name;

                }

                const subcategory_match = subcategories.find(item => item.subcategory_id === subcategory_id);

                if(subcategory_match){

                    product.subcategory_name = subcategory_match.subcategory_name;

                }

            });

            const organized = products.reduce((acc, item) => {

                // Główne kategorie

                let category_id = item.category_id;

                let category_name = item.category_name;

                let category_object = acc.find(obj => obj.category_id === category_id);

                const category_data = categories.find(obj => obj.category_id === category_id);

                let category_description = category_data ? category_data.category_description : "";

                if(!category_object){

                    category_object = { category_id: category_id, category_name: category_name, category_description: category_description, subcategories: [] };
  
                    acc.push(category_object);
  
                }

                const main_index = acc.findIndex(obj => obj.category_id === category_id);

                // Podkategorie

                let subcategory_id = item.subcategory_id;

                let subcategory_name = item.subcategory_name;

                const subcategories = category_object.subcategories;

                let subcategory_object = subcategories.find(obj => obj.subcategory_id === subcategory_id);
                
                if(!subcategory_object){

                    subcategory_object = { subcategory_id: subcategory_id, subcategory_name: subcategory_name, items: [] };

                    acc[main_index].subcategories.push(subcategory_object);

                }

                // Produkty

                const sub_index = acc[main_index].subcategories.findIndex(obj => obj.subcategory_id === subcategory_id);

                acc[main_index].subcategories[sub_index].items.push(item);
                
                return acc;

            }, []);

            /*

            organized.sort((a, b) => a.category_id.localeCompare(b.category_id));

            organized.forEach(item => {

                item.subcategories.sort((a, b) => a.subcategory_id.localeCompare(b.subcategory_id));

                item.subcategories.forEach(obj => {

                    obj.items.sort((a, b) => a.product_name.localeCompare(b.product_name));

                });

            });

            */

            setProductsList(organized);
            
        }

    }, [receivedData]);

    const [splitProducts, setSplitProducts] = useState([]);

    useEffect(() => {

        if(productList.length > 0){

            const products = [...productList];
        
            const output = [];

            const properties = ['product_number', 'diameter', 'size', 'height', 'volume', 'temperature_resistance', 'quantity'];

            products.forEach(list => {

                const subcategories = list.subcategories;

                const all_items = subcategories.flatMap(item => item.items);

                //console.log(all_items)

                const chunked = groupItems(all_items);

                //let category_index_raw = (list.category_id).slice(-1);

                //const category_index = parseInt(category_index_raw) -1;

                const category_index = parseInt((list.category_id).slice(-1));

                const obj = {category_index: category_index, category_name: list.category_name, category_description: list.category_description, all_items: chunked};

                output.push(obj);

            });

            let pages = 3;

            const sorted_output = output.sort((a, b) => a.category_index - b.category_index);

            sorted_output.forEach(list => {

                pages++;

                const current_pages = list.all_items.length -1;

                list.start_page = pages;

                pages += current_pages;

            });

            const last_item = sorted_output.length -1;

            let total_pages = sorted_output[last_item].start_page + sorted_output[last_item].all_items.length;

            setTotalPages(total_pages);

            setSplitProducts(sorted_output);

            function groupItems(all_items){
            
                let chunks = [];

                let index = 0;

                while (index < all_items.length){

                    let count = 0;

                    let chunkSize = 30;

                    let notNullPropsCount = 0; 

                    for(let i = index; i < all_items.length; i++){

                        let nonNullProps = properties.filter(prop => all_items[i][prop] !== null).length;

                        if (nonNullProps >= 5) chunkSize = 20; 

                        else if (nonNullProps >= 3) chunkSize = 25;

                        notNullPropsCount = nonNullProps;

                        count++;

                        if(count >= chunkSize) break;

                    }

                    chunks.push({
                        items: all_items.slice(index, index + chunkSize),
                        properties_number: notNullPropsCount
                    });

                    //chunks.push(all_items.slice(index, index + chunkSize));

                    index += chunkSize;

                }

                return chunks;

            }

         
            /*
            
            function groupItems(all_items, chunkSize = 20){
            
                const chunkedItems = [];

                for (let i = 0; i < all_items.length; i += chunkSize) {

                    chunkedItems.push(all_items.slice(i, i + chunkSize));

                }

                console.log(chunkedItems)
            
                return chunkedItems.map(chunk => ({ items: chunk }));

            }

            */

        }

    }, [productList]);

    console.log(splitProducts)

    // Numerowanie stron

    const [totalPages, setTotalPages] = useState(-1);

    let pageNumber = 0;

    function getPageNumber(){
        pageNumber++;
        //console.log(pageNumber);
        if(pageNumber === totalPages){
            pageNumber = 0;
            return "page_"+totalPages;
        }
        return "page_"+pageNumber;
    }

    // Tło do zdjęć z produktami

    /*

    const GridBackground = () => {

        //const gridSpacing = 5; 

        //const gridCount = 13;

        //const gridVertical = 25;

        const gridSpacing = 3; 

        const gridCount = 22;

        const gridVertical = 42;
      
        return (

            <>

                {[...Array(gridCount)].map((_, i) => {

                    const y = i * gridSpacing;

                    if (y === 0 || y === gridCount * gridSpacing) return null;

                    return (

                        <View
                            key={`h-${i}`}
                            style={{
                                ...styles.line_horizontal,
                                top: y,
                                left: 0,
                                width: '100%',
                                height: 1,
                            }}
                        />

                    );

                })}
        
                {[...Array(gridVertical)].map((_, i) => {

                    const x = i * gridSpacing;

                    if (x === 0 || x === gridVertical * gridSpacing) return null;

                    return (

                        <View
                            key={`v-${i}`}
                            style={{
                                ...styles.line_vertical,
                                top: 0,
                                left: x,
                                width: 1,
                                height: '100%',
                            }}
                        />

                    );

                })}

            </>

        );

    };

    */

    // Dokument PDF

    const GeneratedPDF = () => (

        <Document>
            {/* Strona główna */}
            <Page
                style={styles.page}
                onRender={(props) => {
                    const { pageNumber, totalPages } = props;
                    console.log('page ' + pageNumber + " of " + totalPages);
                }}
                id={`${getPageNumber()}`}
            >
                <Image style={styles.fullPageImage} src={FrontPage}/>
            </Page>
            {/* Spis treści */}
            <Page
                style={styles.page}
                onRender={(props) => {
                    const { pageNumber, totalPages } = props;
                    console.log('page ' + pageNumber + " of " + totalPages);
                }}
                id={`${getPageNumber()}`}
            >
                <View style={styles.contentsPageWrapper}>
                    <View style={styles.contentPageTitleWrapper}>
                        <Text style={styles.contentPageTitle}>Spis treści</Text>
                    </View>
                    <View style={styles.contentPageSidePanel}>
                        <View style={styles.contentPageSidePanelWhite}></View>
                        <View style={styles.contentPageSidePanelInnerWrapper}>
                            {splitProducts.map((obj, index) => (
                                <View key={index}>
                                    <Link style={styles.contentPageSIdePanelLink} src={"#page_"+(obj.start_page)}><Image style={styles.contentPageSidePanelImage} src={'/images/category_icon_' + (obj.category_index) + '.png'} /></Link>
                                </View>
                            ))}
                        </View>
                    </View>
                    <View style={styles.contentPageMainPanel}>
                        {splitProducts.map((obj, index) => (
                            <View style={styles.contentPageMainPanelInnerWrapper} key={index}>
                                <Link style={styles.contentPageMainPanelLink} src={"#page_"+(obj.start_page)}>
                                    <View style={styles.contentPageMainPanelTopRow}>
                                        <Text style={styles.contentPageMainPanelCategoryTitle}>{obj.category_name}</Text>
                                        <Text style={styles.contentPageMainPanelCategoryPage}>{obj.start_page}</Text>
                                    </View>
                                </Link>
                                <Text style={styles.contentPageMainPanelCategoryDescription}>{obj.category_description}</Text>
                            </View>
                        ))}
                    </View>
                </View>

            </Page>
            {/* Strona o firmie */}
            <Page
                style={styles.page}
                onRender={(props) => {
                    const { pageNumber, totalPages } = props;
                    console.log('page ' + pageNumber + " of " + totalPages);
                }}
                id={`${getPageNumber()}`}
            >
                <View style={styles.companyPage}>
                    <View style={styles.companyPageTextWrapper}>
                        <View style={styles.companyPageTextInnerWrapper}>
                            <Text style={styles.companyPageText}>Firma DARFOL Opakowania rozpoczęła swoją działalność w 1989 r. i jest najdłużej działającą firmą z branży  w regionie. Początkowo zajmująca się sprzedażą opakowań foliowych, z czasem znacząco rozszerzyła wachlarz oferowanych produktów. W 2023 r. w związku z dynamicznym rozwojem działalności, zmieniła się siedziba naszej firmy. Jej nowy adres to ulica Ignacego Paderewskiego 35.</Text>
                            <Text style={styles.companyPageText}>W kręgu naszych klientów znajduje się sektor HoReCa, placówki handlowe oraz usługowe, producenci żywności z branży piekarniczo - cukierniczej, przetwórczej, garmażeryjnej oraz mięsnej, urzędy i instytucje publiczne, placówki oświatowe i wychowawcze, przedsiębiorstwa produkcyjne, salony fryzjerskie oraz kosmetyczne, gabinety medyczne, firmy sprzątające i inne.</Text>
                            <Text style={styles.companyPageText}>Chcąc sprostać wzrastającym wymaganiom i oczekiwaniom naszych klientów, oraz poprzez zmieniające się trendy dziedziny opakowań, nasza oferta stale się poszerza o nowe produkty. Zapewniamy również wykonanie indywidualnych nadruków na opakowaniach z różnych tworzyw. Nadruk jest świetnym rozwiązaniem by wyróżnić się wśród konkurencji i budować silną markę.</Text>
                            <Text style={styles.companyPageText}>Dzięki systematycznej współpracy z szerokim gronem dostawców jesteśmy w stanie zaoferować naszym klientom atrakcyjne ceny, fachowe doradztwo, kompleksową obsługę oraz terminowe dostawy.</Text>
                        </View>
                        
                        <View style={styles.companyPageLinkWrapper}>
                            <Link style={styles.companyPageLink} src={"https://opakowania.gniezno.pl/"} target={"_blank"}><Text style={styles.companyPageLinkText}>www.opakowania.gniezno.pl</Text></Link>
                        </View>
                    </View>
                    
                    {<Image style={styles.fullPageBackground} src={CompanyPage}/>}
                </View>
            </Page>
            {/* Produkty */}
            {splitProducts.map((obj, i) => (
                <React.Fragment key={i}>
                    {obj.all_items.map((item, ix) => (
                        <Page
                            style={styles.productPage}
                            onRender={(props) => {
                                const { pageNumber, totalPages } = props;
                                console.log('page ' + pageNumber + " of " + totalPages);
                            }}
                            id={`${getPageNumber()}`}
                            key={ix}
                        >
                            <View style={styles.productPageSidePanel}>
                                {splitProducts.map((category, n) => (
                                    <View key={n} style={(n === i) ? [styles.productPageSidePanelWrapper, styles.White] : styles.productPageSidePanelWrapper}>
                                        <Link style={styles.productPageSidePanelLink} src={"#page_"+(category.start_page)}><Image style={styles.productPageSidePanelImage} src={'/images/category_icon_' + category.category_index + '.png'} /></Link>
                                    </View>
                                ))}
                            </View>
                            <View style={styles.productPageMainPanel}>
                                <View style={styles.productPageMainPanelTopContainer}>
                                    <Text style={styles.productPageMainPanelTopText}>{obj.category_name}</Text>
                                    <View style={styles.productPageMainPanelTopBorder}></View>
                                </View>
                                <View style={styles.productPageMainPanelProductContainer}>
                                    {item.items.map((product, index) => (
                                        <View key={index} style={[styles.singleProductContainer, item.properties_number > 4 ? styles.singleProductContainerLarge : styles.singleProductContainerNormal]}>
                                            <View style={styles.productTopWrapper}>
                                                <View style={styles.productImageWrapper}>
                                                    {/*product.visibility && <GridBackground />*/}
                                                    <Image style={styles.productImage} src={'/images/' + product.filename} />
                                                </View>
                                                <View style={styles.productNameOuterWrapper}>
                                                    <View style={styles.productNameWrapper}>
                                                        <Text style={product.product_name.length > 30 ? [styles.productName, styles.productNameSmall] : [styles.productName, styles.productNameNormal]}>{product.product_name}</Text>
                                                    </View>
                                                </View>
                                            </View>
                                            <View style={[styles.productBottomWrapper, item.properties_number >= 5 ? styles.productBottomWrapperLarge : item.properties_number >= 3 ? styles.productBottomWrapperMedium : styles.productBottomWrapperSmall]}>
                                                {product.product_number && <View style={styles.productDetailsRowWrapper}>
                                                    <View style={styles.productDetailsLeftColumn}>
                                                        <Text style={styles.productDetails}>ART.</Text>
                                                    </View>
                                                    <View style={styles.productDetailsRightColumn}>
                                                        <Text style={styles.productDetails}>{product.product_number ? product.product_number : "-"}</Text>
                                                    </View>
                                                </View>}
                                                {product.product_number && <View style={styles.productDetailsBorder}>
                                                </View>}
                                                {product.diameter && <View style={[styles.productDetailsRowWrapper, styles.productDetailsRowWrapperMoved]}>
                                                    <View style={styles.productDetailsLeftColumn}>
                                                        <Image style={styles.productDiameterImage} src={'/images/icon_diameter.png'} />
                                                    </View>
                                                    <View style={styles.productDetailsRightColumn}>
                                                        <Text style={styles.productDetails}>{product.diameter ? product.diameter : "-"}</Text>
                                                    </View>
                                                </View>}
                                                {product.diameter && <View style={styles.productDetailsBorder}>
                                                </View>}
                                                {product.size && <View style={[styles.productDetailsRowWrapper, styles.productDetailsRowWrapperMoved]}>
                                                    <View style={styles.productDetailsLeftColumn}>
                                                        <Image style={styles.productSizeImage} src={'/images/icon_size.png'} />
                                                    </View>
                                                    <View style={styles.productDetailsRightColumn}>
                                                        <Text style={styles.productDetails}>{product.size ? product.size : "-"}</Text>
                                                    </View>
                                                </View>}
                                                {product.size && <View style={styles.productDetailsBorder}>
                                                </View>}
                                                {product.height && <View style={[styles.productDetailsRowWrapper, styles.productDetailsRowWrapperMoved]}>
                                                    <View style={styles.productDetailsLeftColumn}>
                                                        <Image style={styles.productHeightImage} src={'/images/icon_height.png'} />
                                                    </View>
                                                    <View style={styles.productDetailsRightColumn}>
                                                        <Text style={styles.productDetails}>{product.height ? product.height : "-"}</Text>
                                                    </View>
                                                </View>}
                                                {product.height && <View style={styles.productDetailsBorder}>
                                                </View>}
                                                {product.volume && <View style={[styles.productDetailsRowWrapper, styles.productDetailsRowWrapperMoved]}>
                                                    <View style={styles.productDetailsLeftColumn}>
                                                        <Image style={styles.productVolumeImage} src={'/images/icon_volume.png'} />
                                                    </View>
                                                    <View style={styles.productDetailsRightColumn}>
                                                        <Text style={styles.productDetails}>{product.volume ? product.volume : "-"}</Text>
                                                    </View>
                                                </View>}
                                                {product.volume && <View style={styles.productDetailsBorder}>
                                                </View>}
                                                {product.temperature_resistance && <View style={[styles.productDetailsRowWrapper, styles.productDetailsRowWrapperMoved]}>
                                                    <View style={styles.productDetailsLeftColumn}>
                                                        <Image style={styles.productTemperatureImage} src={'/images/icon_temperature.png'} />
                                                    </View>
                                                    <View style={styles.productDetailsRightColumn}>
                                                        <Text style={styles.productDetails}>{product.temperature_resistance ? 'TAK' : "NIE"}</Text>
                                                    </View>
                                                </View>}
                                                {product.temperature_resistance && <View style={styles.productDetailsBorder}>
                                                </View>}
                                                {product.quantity && <View style={[styles.productDetailsRowWrapper, styles.productDetailsRowWrapperMoved]}>
                                                    <View style={styles.productDetailsLeftColumn}>
                                                        <Image style={styles.productQuantityImage} src={'/images/icon_quantity.png'} />
                                                    </View>
                                                    <View style={styles.productDetailsRightColumn}>
                                                        <Text style={styles.productDetails}>{product.quantity ? (product.quantity + " szt.") : "-"}</Text>
                                                    </View>
                                                </View>}
                                            </View>
                                        </View>
                                    ))}
                                </View>
                                
                                
                                <View style={styles.productPageFooter}>
                                    <Text
                                        style={styles.footerText}
                                        render={({ pageNumber }) => 
                                        `Katalog DARFOL - strona ${pageNumber}`}
                                        fixed
                                    />
                                    <Text style={[styles.footerText, styles.footerTextSeparator]}>/</Text>
                                    <Text
                                        style={styles.footerText}
                                        render={({ totalPages }) => 
                                        `${totalPages}`}
                                        fixed
                                    />
                                </View>
                            </View>
                           
                        </Page>
                    ))}
                    
                </React.Fragment>
            ))}

        </Document>
    );

    const memoizedPDF = useMemo(() => (

        <GeneratedPDF 
            splitProducts={splitProducts}
            currentYear={currentYear}
        />

    ), [splitProducts, currentYear]);

    const [ready, setReady] = useState(false);

    useEffect(() => {

        if(splitProducts.length > 0){

            setReady(true);

        }

    },[splitProducts]);




    return (
        <div id="app-outer-container">
            <div className="app-outer-wrapper">
                <img alt="logo" src={Logo} className="logo-image"></img>
                {ready && 
                    <PDFDownloadLink
                        document={memoizedPDF}
                        fileName={"DARFOL - katalog " + currentYear + ".pdf"}
                    >
                        {({ loading }) => (
                            <div>
                                {loading && 
                                    <div className="container">    
                                        <div className="progress progress-striped">
                                            <div className="progress-bar">
                                            </div>                       
                                        </div> 
                                    </div>
                                }
                                {!loading && 
                                    <div id="button-container">
                                        <button className="buttonDownload">Pobierz katalog</button>
                                    </div>
                                }
                            </div>
                        )}
                    </PDFDownloadLink>
                }
            </div>
            {modal.show &&
                <div className="modal-overlay" onClick={() => closeModal()}>
                    {/* Informacje */}
                    {modal.info && 
                        <div className="modal" onClick={(e)=>e.stopPropagation()}>
                            <div className="modal-header">
                                <h2 className="modal-title">Informacja</h2>
                            </div>
                            <div className="modal-body">
                                {modalMessage && 
                                    <div className="modal-info-wrapper">
                                        <p className="modal-info-text modal-success-text">{modalMessage}</p>
                                    </div>
                                }                   
                            </div>
                            <div className="modal-footer">
                                <div className="modal-buttons-wrapper"> 
                                    {modalMessage && <button className="user-top-panel-button" onClick={() => closeModal()}>OK</button>}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    );
};

/*

// Na wzór

    <Page 
        style={styles.page} 
        onRender={(props) => {
            const { pageNumber, totalPages } = props;
            console.log('page ' + pageNumber + " of " + totalPages);
        }}
        id={`${getPageNumber()}`}
    >
        <View style={styles.titleSection}>
            <Image style={styles.titleBackgroundImage} src={TitleBackground} />
            <Image style={styles.logoText} src={LogoText} />
            <Image style={styles.logoGraphic} src={LogoGraphic} />
            <Text style={styles.titleYear}>{currentYear}</Text>
        </View>
    </Page>
    <Page 
        style={styles.page} 
        onRender={(props) => {
            const { pageNumber, totalPages } = props;
            console.log('page ' + pageNumber + " of " + totalPages);
        }}
        id={`${getPageNumber()}`}
    >
        <View style={styles.titleSection}>
            <Image style={styles.siteBackgroundImage} src={SiteBackground} />
            <View style={styles.listOuterContainer}>
                <Text style={styles.listTitle}>Kategorie produktów:</Text>
                <View style={styles.listInnerContainer}>
                    {splitProducts.map((item, index) => (
                        <Link key={index} style={styles.listLink} src={"#page_"+(item.start_page+1)}><Text style={styles.listText}>{item.category_name}</Text><Text style={styles.listSeparator}></Text><Text style={styles.listPage}>{item.start_page+1}</Text></Link>
                    ))}
                </View>
            </View>
            <View style={styles.footer}>
                <Text style={styles.footerText}>Katalog DARFOL</Text>
                <Text
                    style={styles.footerText}
                    render={({ pageNumber, totalPages }) => 
                    `strona ${pageNumber} / ${totalPages}`}
                    fixed
                />
            </View>
        </View>
    </Page>
    {categoryCount.map((value, i) => (
        <React.Fragment key={i}>
            <Page 
                style={styles.page} 
                onRender={(props) => {
                    // eslint-disable-next-line
                    const { pageNumber, totalPages } = props;
                    console.log('page ' + pageNumber + " of " + totalPages);
                }}
                id={`${getPageNumber()}`}
            >
                <View style={styles.mainSection}>
                    <Image style={styles.siteBackgroundImage} src={SiteBackground} />
                    <View style={styles.mainCategoryContainer}>
                        <Image style={styles.categoryMainImage} src={CategoryImage} />
                        <Text style={styles.categoryMainTitle}>{productList[value].category_name}</Text>
                        <Text style={styles.categoryMainDescription}>{productList[value].category_description}</Text>
                    </View>
                    <View style={styles.footer}>
                        <Text style={styles.footerText}>Katalog DARFOL</Text>
                        <Text
                            style={styles.footerText}
                            render={({ pageNumber, totalPages }) => 
                            `strona ${pageNumber} / ${totalPages}`}
                            fixed
                        />
                    </View>
                </View>
            </Page>
            {splitProducts[i].all_items.map((list, inx) => (
            <Page 
                style={styles.page} 
                key={inx}
                onRender={(props) => {
                    // eslint-disable-next-line
                    const { pageNumber, totalPages } = props;
                    console.log('page ' + pageNumber + " of " + totalPages);
                }}
                id={`${getPageNumber()}`}
            >
                <View style={styles.mainSection}>
                    <Image style={styles.siteBackgroundImage} src={SiteBackground} />
                    <View style={styles.productPageMainContainer}>
                        <View style={styles.sidePanel}>
                            <Link style={styles.sidePanelLink} src={"#page_"+(splitProducts[0].start_page+1)}><Image style={styles.sidePanelImage} src={i === 0 ? Category1Active : Category1NotActive} /></Link>
                            <Image style={styles.sidePanelImage} src={Separator} />
                            <Link style={styles.sidePanelLink} src={"#page_"+(splitProducts[1].start_page+1)}><Image style={styles.sidePanelImage} src={i === 1 ? Category2Active : Category2NotActive} /></Link>
                            <Image style={styles.sidePanelImage} src={Separator} />
                            <Link style={styles.sidePanelLink} src={"#page_"+(splitProducts[2].start_page+1)}><Image style={styles.sidePanelImage} src={i === 2 ? Category3Active : Category3NotActive} /></Link>
                            <Image style={styles.sidePanelImage} src={Separator} />
                            <Link style={styles.sidePanelLink} src={"#page_"+(splitProducts[3].start_page+1)}><Image style={styles.sidePanelImage} src={i === 3 ? Category4Active : Category4NotActive} /></Link>
                            <Image style={styles.sidePanelImage} src={Separator} />
                            <Link style={styles.sidePanelLink} src={"#page_"+(splitProducts[4].start_page+1)}><Image style={styles.sidePanelImage} src={i === 4 ? Category5Active : Category5NotActive} /></Link>
                            <Image style={styles.sidePanelImage} src={Separator} />
                            <Link style={styles.sidePanelLink} src={"#page_"+(splitProducts[5].start_page+1)}><Image style={styles.sidePanelImage} src={i === 5 ? Category6Active : Category6NotActive} /></Link>
                            <Image style={styles.sidePanelImage} src={Separator} />
                            <Link style={styles.sidePanelLink} src={"#page_"+(splitProducts[6].start_page+1)}><Image style={styles.sidePanelImage} src={i === 6 ? Category7Active : Category7NotActive} /></Link>
                            <Image style={styles.sidePanelImage} src={Separator} />
                            <Link style={styles.sidePanelLink} src={"#page_"+(splitProducts[7].start_page+1)}><Image style={styles.sidePanelImage} src={i === 7 ? Category8Active : Category8NotActive} /></Link>
                            <Image style={styles.sidePanelImage} src={Separator} />
                            <Link style={styles.sidePanelLink} src={"#page_"+(splitProducts[8].start_page+1)}><Image style={styles.sidePanelImage} src={i === 8 ? Category9Active : Category9NotActive} /></Link>
                            <Image style={styles.sidePanelImage} src={Separator} />
                            <Link style={styles.sidePanelLink} src={"#page_"+(splitProducts[9].start_page+1)}><Image style={styles.sidePanelImage} src={i === 9 ? Category10Active : Category10NotActive} /></Link>
                            <Image style={styles.sidePanelImage} src={Separator} />
                            <Link style={styles.sidePanelLink} src={"#page_"+(splitProducts[10].start_page+1)}><Image style={styles.sidePanelImage} src={i === 10 ? Category11Active : Category11NotActive} /></Link>
                            <Image style={styles.sidePanelImage} src={Separator} />
                            <Link style={styles.sidePanelLink} src={"#page_"+(splitProducts[11].start_page+1)}><Image style={styles.sidePanelImage} src={i === 11 ? Category12Active : Category12NotActive} /></Link>
                        </View>
                        <View style={styles.mainPanel}>
                            <Text style={styles.categoryTitle}>{productList[i].category_name}</Text>
                            <View style={styles.productSection}>
                                {list.items.map((item, index) => (
                                    <View key={index} style={styles.productContainer}>
                                        <Image style={styles.productImage} src={'/product_images/'+item.filename} />
                                        <View style={styles.productNameContainer}>
                                            <Text style={styles.productName}>{item.product_name}</Text>
                                        </View>
                                        <Text style={styles.productNumber}>{item.product_number}</Text>
                                        <View style={styles.barcodeContainer}>
                                            <Image style={styles.barcodeImage} src={createPNG(item.barcode)} />
                                            <View style={styles.barcodeTextContainer}>
                                                <Text style={styles.barcodeText}>{item.barcode}</Text>
                                            </View>
                                        </View>
                                    </View>
                                ))}
                            </View>
                        </View>
                    </View>
                    <View style={styles.footer}>
                        <Text style={styles.footerText}>Katalog DARFOL</Text>
                        <Text
                            style={styles.footerText}
                            render={({ pageNumber, totalPages }) => 
                            `strona ${pageNumber} / ${totalPages}`}
                            fixed
                        />
                    </View>
                </View>
            </Page>
            ))}
        </React.Fragment>
    ))}

// Barcode

const canvas = useRef(null);

<canvas ref={canvas}></canvas>

<img alt="" src="http://localhost/images/1-1.jpg"></img>

<Barcode 
    value="1398135337740" 
    format="EAN13" 
    width={2}
    height={25}
    textMargin={0}
    fontSize={20}
/>

// Inne

{({ loading }) => (loading ? 'Loading document...' : 'Download PDF')}

*/